// The ONE floating popover layer (.cb-float-root) shared by every screen that renders
// imperative popovers (cashbook / dashboard / journals / reports / settings). Screens used
// to each create their own root AND add their own document click listener on every mount —
// the listeners were never removed, so a session accumulated one per visit, each pinning
// its dead popover DOM. Here the click-outside listener binds ONCE at module load and the
// root is reused across mounts.
let root = null;

// Called once per screen mount: returns the (emptied) shared layer, creating it on first use.
export function mountFloatRoot(){
  document.querySelectorAll('.cb-float-root').forEach(el => { if(el !== root) el.remove(); });
  if(!root){
    root = document.createElement('div');
    root.className = 'cb-float-root';
  }
  root.innerHTML = '';
  if(root.parentNode !== document.body) document.body.appendChild(root);
  return root;
}

export function closeFloatRoot(){ if(root) root.innerHTML = ''; }

// ONE app-wide click-outside close — anchors opt out with [data-float-anchor].
document.addEventListener('click', e => {
  if(!e.target.closest('.cb-float-root') && !e.target.closest('[data-float-anchor]')) closeFloatRoot();
});
